export default __webpack_public_path__ + "static/media/docs.1a721f0e.png";